<template>
 <section class="w-full max-w-[1270px]">
  <ModalHeader
    title="임직원 검색"
    class="pb-[90px]"
    @onSubmit="handleSearch"
  >
   <template #filter>
    <ul class="flex flex-col flex-1 gap-3">
     <li class="inline-flex w-full gap-[26px]">
      <!-- <Select
       placeholder="본부전체"
       :options="['본부전체']"
       v-model="filter.dept_dv_code_nm"
       class="min-w-[150px]"
      />
      <Select
        placeholder="직급전체"
        :options="['직급전체']"
        v-model="filter.grd_dv_code_nm"
        class="min-w-[150px]"
      /> -->
      <Input
        placeholder="이름을 검색하세요"
        class="flex-1 bg-white [&_input]:bg-white"
        v-model="filter.name"
      >
      <template #icon>
       <img
         :src="search"
         alt="search"
         class="mr-1"
       />
      </template>
      </Input>
     </li>
    </ul> 
   </template>
  </ModalHeader>
  <div class="flex items-center pt-5 pb-[18px] max-w-[1096px] mx-auto">
  
   <strong class="font-semibold text-sm leading-7 -tracking-[0.2px] ml-1">임직원</strong>
   <span class="text-[#B80E14] font-semibold text-sm leading-7 ml-2">{{ rows.length }} 명</span>
   <Select
     class="min-w-[72px] ml-3 border border-gray-04"
     placeholder="10"
     :options="[10, 30, 50, 100]"
     v-model="perPage"
     @update:model-value="(val) => perPage = val"
   /> 

   <p class="max-w-[1096px] ml-auto text-xs font-semibold leading-7 text-gray-04 -tracking-[0.2px]">
    추가할 임직원을선택해주세요.
  </p>
  </div>

  <Table
    :rows="rows"
    class="w-full max-w-[1096px] mx-auto "
    :columns="columns"
    :pagination="pagination"
    @update:page="(newPage) => page = newPage"
  >
  <template #td-action="{ row }">
   <button
     class="border border-[#888888] rounded-5 px-2 py-1 bg-white leading-4"
     @click="$emit('selected', row)"
   >Select</button>
  </template>
  </Table> 
 </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import search from '@/assets/search.svg'
import Select from '@/components/ui/Select.vue'
import Input from '@/components/ui/Input.vue'
import ModalHeader from '@/components/ui/ModalHeader.vue'
import Table from '@/components/ui/Table.vue'

const filter = ref({
 dept_dv_code_nm: '',
 grd_dv_code_nm: '',
 name: ''
})

const columns = [
 { label: '조직명', value: 'dept_dv_code_nm' },
 { label: '이름', value: 'mber_nm' },
 { label: '이메일', value: 'email' },
 { label: '직급', value: 'grd_dv_code_nm' },
 { label: '영역', value: 'dty_dv_code_nm' },
 { label: '', value: 'action' },
]

const rows = ref([])
const store = useStore()
async function handleSearch() {
 await store.dispatch('user/fetchGigUsers')
 const res = store.getters['user/allGigUsers']
 rows.value = res.filter((data) => data.mber_nm.includes(filter.value.name))
}
handleSearch()

const page = ref(1)

const perPage = ref(10)

const pagination = computed({
 get() {
  return {
   page: page.value,
   perPage: perPage.value,
   lastPage: Math.ceil(rows.value.length / 10),
  }
 },
 set(val) {
  return val
 }
});
</script>

<style lang="scss" scoped></style>